import { render, staticRenderFns } from "./ReportResidentNotify.vue?vue&type=template&id=4d017734&"
import script from "./ReportResidentNotify.vue?vue&type=script&lang=js&"
export * from "./ReportResidentNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports